<div class="mg-silh-landing-layout">
  <div class="content-container"><ng-content></ng-content></div>
  <div class="foot-bg-placeholder"></div>
  <div class="foot-bg"></div>
</div>
